<template>
  <div class="main editAppealMain">
    <!-- 上部分 -->
    <div class="title">
      <span class="text">
        会员诉求
        <span>
          (
          <span style="color: #FF0000">*</span>为必填项)
        </span>
      </span>
    </div>

    <!-- 下部分 -->
    <el-form label-width="400px" ref="form">
      <el-form-item label="真实姓名" required>
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="担任职务" required>
        <el-input v-model="form.position"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" required>
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="标题名称" required>
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="详细内容" required>
        <el-input type="textarea" v-model="form.content" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
      </el-form-item>
    </el-form>
    <div class="btn">
      <el-button type="plain" @click="reset">重置</el-button>
      <el-button type="primary" @click="submit">提交</el-button>
    </div>
  </div>
</template>

<script>
import * as Cache from '../utils/cache'
import * as API from '../utils/apiService'

export default {
  data () {
    return {
      form: {
        name: '',
        position: '',
        phone: '',
        title: '',
        content: ''
      },
      id: ''
    }
  },
  methods: {
    reset () {
      this.$refs.form.resetFields()
    },
    submit () {
      if (!this.form.name) {
        this.$message.error('请输入真实姓名')
        return
      }
      if (!this.form.position) {
        this.$message.error('请输入担任职务')
        return
      }
      if (!this.form.phone) {
        this.$message.error('请输入联系电话')
        return
      }
      if (!this.form.title) {
        this.$message.error('请输入标题名称')
        return
      }
      if (!this.form.content) {
        this.$message.error('请输入详细内容')
        return
      }
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.id = resp.data.id
          let _params = {
            name: this.form.name,
            position: this.form.position,
            phone: this.form.phone,
            title: this.form.title,
            content: this.form.content,
            membershipid: this.id
          }
          API.addFeedBack(_params).then(resp => {
            if (resp.resultCode === '0000') {
              this.$message.success('诉求已发送')
              this.$router.push('/appeal')
            }
          })
        }
      })      
    }
  }
}
</script>

<style lang="scss" scoped>
.editAppealMain{
  .el-form{
    .el-textarea{
      width: 60%;
    }
  }
  .btn{
    margin-left: 400px;
  }
}
</style>
